import { useCountries, useGTM, useStatuses, useTechnologies } from "hooks";
import { useContext, useEffect } from "react";
import QueryContext from "state/query";
import Counters from "./Counters";
import SelectCountries from "./CountriesFilter";
import ResetFilters from "./ResetFilters";
import ResetMap from "./ResetMap";
import SelectStatuses from "./SelectStatuses";
import SelectTechnologies from "./SelectTechnologies";

export default function FilterBar() {
  const { technologies, countries, statuses } = useContext(QueryContext);
  const { dataLayer } = useGTM();
  const { countries: allCountries } = useCountries();
  const { technologies: allTechs } = useTechnologies();
  const { statuses: allStatuses } = useStatuses();

  useEffect(() => {

      let data;
    if (
      countries?.length === 0 &&
      technologies?.length === 0 &&
      statuses?.length === 0
    ) {
        data ={
            technologies:[],
            countries:[],
            statuses:[]
        };
    }else {

        data = {
            technologies:
                allTechs
                    ?.filter((t) => technologies.includes(t.id))
                    ?.map((t) => {
                        return { id: t.id, name: t.name };
                    }) || [],
            countries:
                allCountries
                    ?.filter((c) => countries.includes(c.id))
                    ?.map((c) => {
                        return { id: c.id, name: c.name, code: c.acf.country_code };
                    }) || [],
            statuses:
                allStatuses
                    ?.filter((t) => statuses.includes(t.id))
                    ?.map((t) => {
                        return { id: t.id, name: t.name };
                    }) || []
        }
    }

      dataLayer.push({
          event: "cefic_gip_map.filters.clear_datalayer",
          technologies: undefined,
          countries: undefined,
          statuses: undefined
      })
    dataLayer.push({
      event: "cefic_gip_map.filters.update",
      ...data
    });
  }, [
    technologies,
    countries,
    statuses,
    dataLayer,
    allCountries,
    allTechs,
    allStatuses,
  ]);
  return (
    <div>
      <Counters cssClasses="lg:hidden text-primary-500 px-8" />
      <div className="flex w-full justify-between text-primary-500">
        <ResetMap />
        <Counters cssClasses="hidden lg:flex" />
        <div className="flex flex-nowrap grow">
          <div className="grow shrink basis-0 text-center">
            <SelectCountries />
          </div>
          <div className="grow shrink basis-0 text-center">
            <SelectStatuses />
          </div>
          <div className="grow shrink basis-0 text-center">
            <SelectTechnologies />
          </div>
        </div>
        <ResetFilters />
      </div>
    </div>
  );
}
